import React from 'react'

import { useHistory } from 'react-router-dom'

import { Button, Card, Flex, Header, Text } from '@driftt/dds'

import useCalendarStatus from 'hooks/useCalendarStatus'
import useIsAdmin from 'hooks/useIsAdmin'

export default function Page() {
  const history = useHistory()
  const { data } = useCalendarStatus()
  const isAdmin = useIsAdmin()

  if (!data) {
    return null
  }

  if (data.connected || isAdmin) {
    history.replace('/')
  }

  return (
    <Card css={{ width: 514, margin: '0 auto', textAlign: 'center' }}>
      <Card.Header>
        <Header variant="h2">
          Connect a calendar to get started with Drift meetings
        </Header>
      </Card.Header>
      <Card.Content as={Flex} direction="column">
        <Text>
          Connect an individual calendar for yourself or an organizational
          calendar for your business to start booking meetings with Drift.
        </Text>
        <Button
          css={{ width: '100%', marginTop: '$2' }}
          onClick={() =>
            window.open(`/settings2/meetings${isAdmin ? '/organization' : ''}`)
          }
        >
          Go to Settings
        </Button>
      </Card.Content>
    </Card>
  )
}

Page.Header = function PageHeader() {
  return <Header variant="h1">Meetings</Header>
}
